<script>
	// From Lucide
	import { MessagesSquare } from 'lucide-svelte';

	export let iconClass = '';
</script>

<MessagesSquare class={iconClass} />
